<template>

  <div v-if="this.$store.state.fetchVereinComplete == true" class="mt-8 flex flex-wrap w-full">

    <div class="w-full md:w-1/2">

      <div class="w-full md:w-11/12 mx-auto">

        <img :src="$store.state.vereinMain.bild.url" alt="">

      </div>

    </div>

    <div class="w-full md:w-1/2 p-4">

      <h1 class="text-gray-800 text-4xl text-left"> {{ $store.state.vereinMain.titel }} </h1>

      <div v-html="$store.state.vereinMain.text" > </div>

      <div class="flex mt-8">

        <router-link tag="button" class="bg-orange-300 hover:bg-orange-400 text-gray-800 font-bold py-4 px-8 mr-12 rounded block text-black" to="/verein/mitglied">

            <span> Mitglied werden</span>

        </router-link>

        <a target="_blank" href="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/09/QR_Rechnung.pdf">
          <button class=" hover:bg-orange-300 text-gray-800 font-bold py-4 px-4 rounded block border-4 border-orange-300">
            <span>Spenden</span>
          </button>
        </a>

      </div>

    </div>

    <div class="w-full flex content-start flex-wrap mx-6">
      <div class="w-full md:w-1/2 p-2">
        <div class="shadow-md rounded-lg p-4 text-gray-700 h-full text-center bg-blue-100 p-2">

          <h1 class="text-left mb-4"> {{ $store.state.vereinLeft.titel }} </h1>

          <div v-html="$store.state.vereinLeft.text"> </div>

        </div>

      </div>
      <div class="w-full md:w-1/2 p-2">
        <div class="p-4 text-gray-700 shadow-md rounded-lg h-full text-center bg-blue-100 p-2">

          <h1 class="text-left mb-4"> {{ $store.state.vereinMiddle.titel }} </h1>

          <div v-html="$store.state.vereinMiddle.text" > </div>

        </div>
      </div>
      <div class=" md:w-1/2 p-2 w-full">
        <div v-if="$store.state.fetchDownloadsComplete" class="p-4 text-gray-700 h-full text-center bg-white p-2">

          <h1 class="text-left mb-4"> Downloads</h1>

          <div v-for="index in sortDownloads" v-bind:key="index.text" class="mt-2 text-left">

            <a v-if="index.selection == 'download' " :href="index.file.url" target="_blank" class="text-left text-lg text-blue-600 cursor-pointer no-underline"> <i class="fas fa-cloud-download-alt"></i> {{index.text}} </a>

          </div>

        </div>
      </div>

      <div class="w-full md:w-1/2 p-2">
        <div v-if="$store.state.fetchDownloadsComplete" class="p-4 text-gray-700 h-full text-center bg-white p-2">

          <h1 class="text-left mb-4"> Links</h1>

          <div v-for="index in sortDownloads" v-bind:key="index.text" class="mt-2 text-left">

            <a v-if="index.selection == 'link' " :href="index.url" target="_blank" class="text-left text-lg text-blue-600 cursor-pointer no-underline"> <i class="fas fa-link"></i> {{index.text}} </a>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {

  },
  name: 'VereinAbout',
  props: {

  },
  data() {
    return {

    }
  },
  methods: {

    compare(a, b) {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    },


  },
  mounted: function(){

  },

  computed: {

    sortDownloads() {
      // console.log(this.data.slice().sort(this.compare));

      return this.$store.state.downloads.slice().sort(this.compare);
    },

    sortVerein() {
      // console.log(this.data.slice().sort(this.compare));

      var result = this.$store.state.verein.filter(obj => {
        return obj.id === 1;
      })

      // console.log(result);

      return result
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#map{
  height: 100%;
  width: 50%;

}

button{
  // display: block;

}

</style>
